/*global $*/
/*eslint no-undef: "error"*/
export default class ReviewList {
    classItem = 'review-list--item'
    classButton = 'review-list--button'
    classTitle = 'review-list--title'
    classTitleHidden = 'title---hidden'
    classOpen = 'review-list---open'

    constructor () {
        let self = this

        $(`.${self.classButton}`).click(function () {
            $(`.${self.classItem}`).addClass(self.classOpen)
            $(`.${self.classTitle}`).addClass(self.classTitleHidden)
        })
    }
}
